import * as yup from "yup";

import { requiredMessage } from "../validationMessages";

import { trimmedString } from "./trimmedString";

export const countryValidator = yup
  .object()
  .shape({
    label: trimmedString,
    value: trimmedString,
  })
  .typeError(requiredMessage);
export const countryValidatorRequired = yup
  .object()
  .shape({
    label: trimmedString,
    value: trimmedString,
  })
  .typeError(requiredMessage)
  .required();
